"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelTariffCardMobile = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _HotelTariffOffer = require("./HotelTariffOffer/HotelTariffOffer");
var _HotelRoomFacilities = _interopRequireDefault(require("../HotelRoomDescription/HotelRoomFacilities"));
var _MobileRoomGallery = _interopRequireDefault(require("../MobileRoomGallery"));
var _CashBack = _interopRequireDefault(require("../CashBack"));
var _Tab = _interopRequireDefault(require("../Tab"));
var _Tabs = _interopRequireDefault(require("../Tabs"));
var _HotelRoomName = _interopRequireDefault(require("../HotelRoomDescription/HotelRoomName"));
var _EmptyGallery = _interopRequireDefault(require("../EmptyGallery"));
var _LabelList = require("../Label/LabelList");
var _ChevronDown = _interopRequireDefault(require("../../icons-react/rebrand/ChevronDown"));
var _MobilePopupBottom = _interopRequireDefault(require("../MobilePopupBottom"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelTariffCardMobile = exports.HotelTariffCardMobile = function HotelTariffCardMobile(_ref) {
  var onOfferClicked = _ref.onOfferClicked,
    bonusCount = _ref.bonusCount,
    area = _ref.area,
    hotelFacilities = _ref.hotelFacilities,
    labels = _ref.labels,
    mealTypes = _ref.mealTypes,
    tourists = _ref.tourists,
    room = _ref.room,
    offers = _ref.offers,
    onClickGallery = _ref.onClickGallery,
    labelColor = _ref.labelColor,
    textColor = _ref.textColor,
    size = _ref.size,
    cashbackLabel = _ref.cashbackLabel,
    className = _ref.className,
    hasCashbackLabel = _ref.hasCashbackLabel,
    cashbackIconWebp = _ref.cashbackIconWebp,
    cashbackIconPng = _ref.cashbackIconPng,
    cashbackTooltipText = _ref.cashbackTooltipText;
  var images = room.images,
    description = room.description,
    facilities = room.facilities,
    roomName = room.name_ru,
    originalName = room.name_en,
    idRoom = room.id;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var options = {
    showHandlebar: true
  };
  var roomImages = (0, _react.useMemo)(function () {
    return images ? images.map(function (image) {
      return image.x900;
    }) : [];
  }, [images]);
  var existRoomImages = roomImages.length !== 0;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledHotelTariffCard, null, bonusCount ? /*#__PURE__*/_react["default"].createElement(_CashBack["default"], {
    count: "+".concat(bonusCount),
    isMobile: true,
    labelColor: labelColor,
    textColor: textColor,
    size: size,
    label: cashbackLabel,
    className: "hotelMobile",
    cashbackIconWebp: cashbackIconWebp,
    cashbackIconPng: cashbackIconPng,
    cashbackTooltipText: cashbackTooltipText,
    hasCashbackLabel: hasCashbackLabel
  }) : null, roomImages.length ? /*#__PURE__*/_react["default"].createElement(StyledGallery, {
    onClickGallery: onClickGallery,
    images: roomImages,
    id: idRoom
  }) : /*#__PURE__*/_react["default"].createElement(_EmptyGallery["default"], null), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(_HotelRoomName["default"], {
    name: roomName,
    originalName: originalName,
    area: area,
    headerFontSize: 18
  }), /*#__PURE__*/_react["default"].createElement(StyldLabelList, {
    labels: labels,
    maxLabels: 6
  }), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description), hotelFacilities ? /*#__PURE__*/_react["default"].createElement(StyledFacilitiesHintButton, {
    onClick: function onClick() {
      return setShowPopup(true);
    },
    $isOpened: showPopup
  }, /*#__PURE__*/_react["default"].createElement(StyledTooltipText, null, _localization.i18n.t('hotel.room.roomFacilities')), /*#__PURE__*/_react["default"].createElement(StyledChervonDown, {
    $isOpened: showPopup
  })) : null), /*#__PURE__*/_react["default"].createElement(StyledTariffes, null, mealTypes.map(function (_ref2) {
    var id = _ref2.id,
      descriptionMeal = _ref2.description;
    var offersTariff = offers[id];
    return offersTariff ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledDescriptionMeal, {
      key: "meal_".concat(descriptionMeal)
    }, descriptionMeal), /*#__PURE__*/_react["default"].createElement("div", null, offersTariff.map(function (offer, idxOffer) {
      var key = "".concat(idxOffer - offer.price);
      return /*#__PURE__*/_react["default"].createElement(_HotelTariffOffer.HotelTariffOffer, {
        key: key,
        tourists: tourists,
        onOfferClicked: onOfferClicked,
        offer: offer,
        isMobile: true
      });
    }))) : null;
  })), showPopup && /*#__PURE__*/_react["default"].createElement(_MobilePopupBottom["default"], {
    visible: showPopup,
    onClick: function onClick() {
      return setShowPopup(false);
    },
    options: options
  }, /*#__PURE__*/_react["default"].createElement(StyledPopupRommName, null, /*#__PURE__*/_react["default"].createElement(_HotelRoomName["default"], {
    name: roomName,
    originalName: originalName,
    area: area,
    headerFontSize: 18
  })), /*#__PURE__*/_react["default"].createElement(StyledHotelRoomFacilities, {
    facilities: facilities,
    description: description,
    hotelFacilities: hotelFacilities,
    isMobile: true
  }))));
};
var StyledGallery = (0, _styledComponents["default"])(_MobileRoomGallery["default"]).withConfig({
  displayName: "HotelTariffCardMobile__StyledGallery",
  componentId: "sc-19z440u-0"
})(["border-radius:var(--border-radius);overflow:hidden;"]);
var StyledHotelTariffCard = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledHotelTariffCard",
  componentId: "sc-19z440u-1"
})(["width:100%;padding:8px;border-radius:var(--border-radius);background-color:var(--white);position:relative;"]);
var StyledDescriptionMeal = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledDescriptionMeal",
  componentId: "sc-19z440u-2"
})(["font-size:18px;padding:8px;line-height:22px;font-weight:500;"]);
var StyledDescription = _styledComponents["default"].span.withConfig({
  displayName: "HotelTariffCardMobile__StyledDescription",
  componentId: "sc-19z440u-3"
})(["overflow:hidden;max-height:2.2858em;font-size:14px;line-height:16px;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;@mixin truncate-two-lines;"]);
var StyledTariffes = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledTariffes",
  componentId: "sc-19z440u-4"
})(["display:flex;flex-direction:column;> ", ":not(:first-child){border-top:1px solid var(--grey3);}"], StyledDescriptionMeal);
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledWrapper",
  componentId: "sc-19z440u-5"
})(["margin-top:6px;margin-left:10px;display:flex;gap:4px;flex-direction:column;"]);
var StyledFacilitiesHintButton = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledFacilitiesHintButton",
  componentId: "sc-19z440u-6"
})(["color:var(--grey1);background-color:transparent;cursor:pointer;display:flex;align-items:center;padding-bottom:16px;border-bottom:1px solid var(--grey3);", ";"], function (_ref3) {
  var $isOpened = _ref3.$isOpened;
  return $isOpened && "color: var(--secondary);";
});
var StyledTooltipText = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledTooltipText",
  componentId: "sc-19z440u-7"
})(["font-size:14px;line-height:16px;"]);
var StyledChervonDown = (0, _styledComponents["default"])(_ChevronDown["default"]).withConfig({
  displayName: "HotelTariffCardMobile__StyledChervonDown",
  componentId: "sc-19z440u-8"
})(["width:12px;height:12px;margin-left:2px;path{fill:var(--grey1);}", ""], function (_ref4) {
  var $isOpened = _ref4.$isOpened;
  return $isOpened && "\n    rotate: 180deg;\n\n    path {\n      fill: var(--secondary);\n    }\n";
});
var StyldLabelList = (0, _styledComponents["default"])(_LabelList.LabelList).withConfig({
  displayName: "HotelTariffCardMobile__StyldLabelList",
  componentId: "sc-19z440u-9"
})(["margin-top:8px;"]);
var StyledTabs = (0, _styledComponents["default"])(_Tabs["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "HotelTariffCardMobile__StyledTabs",
  componentId: "sc-19z440u-10"
})(["display:flex;margin:10px 0;"]);
var StyledTab = (0, _styledComponents["default"])(_Tab["default"]).withConfig({
  displayName: "HotelTariffCardMobile__StyledTab",
  componentId: "sc-19z440u-11"
})(["padding:8px 12px;color:var(--black);font-size:14px;font-style:normal;font-weight:500;line-height:16px;", ";"], function (_ref5) {
  var selected = _ref5.selected;
  return selected && (0, _styledComponents.css)(["background-color:var(--background);border-radius:var(--border-radius);"]);
});
var StyledTabContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledTabContent",
  componentId: "sc-19z440u-12"
})(["display:", ";"], function (_ref6) {
  var isVisible = _ref6.isVisible;
  return isVisible ? 'block' : 'none';
});
var StyledHotelRoomFacilities = (0, _styledComponents["default"])(_HotelRoomFacilities["default"]).withConfig({
  displayName: "HotelTariffCardMobile__StyledHotelRoomFacilities",
  componentId: "sc-19z440u-13"
})(["margin:10px;"]);
var StyledPopupRommName = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledPopupRommName",
  componentId: "sc-19z440u-14"
})(["margin-left:10px;"]);